// extracted by mini-css-extract-plugin
module.exports = {"bar":"navbar-module--bar--3wu8b","spacer":"navbar-module--spacer--1-tNd","logo":"navbar-module--logo--3J-9K","buttonbox":"navbar-module--buttonbox--uJUk6"};